// extracted by mini-css-extract-plugin
export default {"container":"ReportsPage_container_ow4D_","content":"ReportsPage_content_RaQ77","menuExpaned":"ReportsPage_menuExpaned_n0GPK","wrapper-report":"ReportsPage_wrapper-report_tte4C"};